/**
 * InventoryNav — thin sub-navigation shell mounted at /inventory.
 *
 * Inventory is the sole top-level Ops nav item (see Layout.jsx); the
 * "Costs | Recipes | Stock" tab strip below is reached only through this
 * shell, and the legacy top-level /baking path redirects here (see App.js).
 * Costs (the original `/inventory` index route) and Recipes carry no
 * SensitivePageGate — that was true before this move and this relocation
 * does not change it. Stock (TT-501 Phase 4) wraps the existing TI
 * (phone bin-tracking) backend for desktop/tablet oversight and is gated
 * entirely on the TS admin bridge, not on a page-level gate here.
 */
import SectionNav from "@/components/SectionNav";
import { prefetchRecipes } from "@/features/recipes/recipesQueryClient";
import { Outlet } from "react-router-dom";

function prefetchRecipesChunk() {
  void import("@/features/recipes/BakingV2Root");
}

function warmRecipes() {
  prefetchRecipesChunk();
  void prefetchRecipes();
}

function warmStock() {
  void import("@/features/inventory/ops-stock/OpsStockRootRoute");
}

const TABS = [
  { to: "/inventory", label: "Costs", end: true },
  {
    to: "/inventory/recipes",
    label: "Recipes",
    end: false,
    onHover: warmRecipes,
  },
  {
    to: "/inventory/stock",
    label: "Stock",
    end: false,
    onHover: warmStock,
  },
];

export default function InventoryNav() {
  return (
    <div className="min-w-0" data-testid="inventory-nav">
      <SectionNav tabs={TABS} ariaLabel="Inventory sections" testIdPrefix="inventory" />
      <Outlet />
    </div>
  );
}
